import { type Transaction } from '@kalos/kalos-rpc';
import { useMemo } from 'react';

import { createTransactionLineItemsStore } from '.';
import { TransactionLineItemsStoreContext } from './TransactionLInteItemsStoreContext';

export const withTransactionLineItemsStoreContext = <
  T extends object & { transaction: Transaction; circumventCostCenterRequired?: boolean },
>(
  Component: React.ComponentType<T>,
) => {
  return (props: T) => {
    const store = useMemo(() => {
      return createTransactionLineItemsStore(props.transaction, props.circumventCostCenterRequired);
    }, [props.transaction, props.circumventCostCenterRequired]);

    return (
      <TransactionLineItemsStoreContext value={store}>
        <Component {...props} />
      </TransactionLineItemsStoreContext>
    );
  };
};
